import { Box, Typography } from "@mui/material";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import { useTranslation } from "react-i18next";

export function PlanMedicationHeader({ patient }) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "16px",
        p: "24px",
        mb: "24px",
        boxShadow: "0px 0px 16px rgba(30, 39, 79, 0.08)",
        display: "flex",
        alignItems: "center",
        gap: "16px"
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          bgcolor: semanticColors.border.middle,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}
      >
        <FontAwesomeIcon
          icon={faUser}
          style={{ color: semanticColors.text.primary, fontSize: 24 }}
        />
      </Box>

      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "wrap"
          }}
        >
          <Typography
            sx={{ ...typography.heading.l, color: semanticColors.text.primary }}
          >
            {patient?.name || "João Paulo Silva"}
          </Typography>
          <Box
            sx={{
              bgcolor: semanticColors.border.middle,
              borderRadius: "8px",
              px: "4px",
              py: "2px"
            }}
          >
            <Typography
              sx={{
                ...typography.body.lSemibold,
                color: semanticColors.text.secondary
              }}
            >
              {patient?.age || "68"} anos
            </Typography>
          </Box>
        </Box>
        <Typography
          sx={{
            ...typography.body.l,
            color: semanticColors.text.secondary,
            mt: "4px"
          }}
        >
          {t("planMedication.updated")}:{" "}
          {patient?.updatedBy || "Dr. Ricardo Pimenta Araújo"} em{" "}
          {moment().format("DD/MM/YYYY [às] HH:mm")}
        </Typography>
      </Box>
    </Box>
  );
}
